import patioWalkwayPassaic from "@/assets/mp-patio-walkway-paving-passaic-nj-041026.webp";
import illuminatedStepsVerona from "@/assets/mp-illuminated-paver-steps-verona-nj-041326.webp";
import stepsPavedWalkwayVerona from "@/assets/steps-paved-walkway-verona-nj.webp";
import paverPatioInstPequannock2 from "@/assets/paper-patio-installation-pequannock-nj-2.webp";
import stepsPassaic2 from "@/assets/mp-steps-and-stoops-installation-passaic-nj-041026-2.webp";
import paverPatioFirePitClifton from "@/assets/mp-masonry-paver-patio-clifton-nj-g-04052026.webp";
import stepsInstallationClifton from "@/assets/mp-steps-and-stoops-installation-passaic-nj-041026.webp";
import concreteDrivewayClifton from "@/assets/mp-concrete-driveway-clifton-nj-041026.webp";
import halfCourtNorthCaldwell from "@/assets/custom-masonry-concrete-half-court-north-caldwell-essex-county-nj.webp";
import outdoorKitchenNorthHaledon from "@/assets/custom-masonry-outdoor-kitchen-north-haledon-passaic-county-nj.webp";
import patioNorthHaledonPassaic from "@/assets/patio-paver-installation-north-haledon-passaic-county-nj.webp";
import retainingWallConstructionTotowa from "@/assets/retaining-wall-construction-totowa-nj.webp";
import paverPatioNorthHaledon from "@/assets/paver-patio-installation-north-haledon-nj.webp";
import paverPatioKinnelon from "@/assets/paver-patio-by-pool-kinnelon-nj.webp";
import retainingWallNutley from "@/assets/retaining-wall-installation-nutley-nj.webp";
import stoneMasonryOakland from "@/assets/stone-masonry-installation-oakland-nj.webp";
import outdoorKitchenPomptonLakes from "@/assets/outdoor-kitchen-installation-pompton-lakes-nj.webp";
import fireplaceMahwah from "@/assets/fireplace-installation-mahwah-nj-hero.webp";
import patioLivingston from "@/assets/patio-paver-livingston-essex-county-nj.webp";
import walkwayBloomfield from "@/assets/masonry-walkway-bloomfield-essex-county-nj.webp";
import retainingWallWestOrange from "@/assets/retaining-wall-west-orange-essex-county-nj.webp";
import stepsStoopsWayne from "@/assets/mp-steps-stoops-installation-wayne-nj-61526.webp";
import patioDenville from "@/assets/paver-patio-installation-denville-morris-county-nj.webp";
import brickStepsTotowa from "@/assets/brick-masonry-steps-totowa-nj.webp";
import sidewalkWayne from "@/assets/concrete-sidewalk-installation-wayne-nj.webp";
import firePitNorthCaldwell from "@/assets/fire-pit-installation-north-caldwell-nj-2.webp";
import stoneStepsMontclair from "@/assets/stone-masonry-steps-installation-montclair-nj.webp";
import retainingWallMorrisTownship from "@/assets/retaining-wall-morris-township-morris-county-nj.webp";
import drivewayLeonia from "@/assets/bergen-county-driveway-paver-installation-leonia-nj.webp";
import patioWallClifton from "@/assets/paver-patio-masonry-wall-clifton-nj.webp";
import stoneWallStepsFranklinLakes from "@/assets/stone-retaining-wall-steps-franklin-lakes-nj-2.webp";
import outdoorKitchenMontclair from "@/assets/outdoor-kitchen-montclair-nj.webp";
import retainingWallNutley2 from "@/assets/retaining-wall-installation-nutley-essex-county-nj-2.webp";
import retainingWallOldTappan from "@/assets/retaining-wall-hardscape-old-tappan-bergen-county-nj.webp";
import firePitEssexFells from "@/assets/fire-pit-installation-essex-fells-nj.webp";
import firePitNorthHaledon from "@/assets/fire-pit-installation-north-haledon-nj-2.webp";
import stepsTotowa2 from "@/assets/masonry-steps-totowa-passaic-county-nj2.webp";
import stepsNorthHaledon from "@/assets/masonry-brick-steps-north-haledon-nj.webp";
import paverPatioBloomfield from "@/assets/paver-patio-fire-pit-bloomfield-nj.webp";
import bluestonePatioHackensack from "@/assets/new-bluestone-patio-pavers-hackensack-nj.webp";
import paverPatioFirePitCloster from "@/assets/paver-patio-fire-pit-closter-nj.webp";
import stoneMasonryCaldwell from "@/assets/stone-masonry-construction-caldwell-nj.webp";
import paverWalkwayWayne2 from "@/assets/paver-walkway-installation-wayne-nj2.webp";
import paverPatioReplacementWayne2 from "@/assets/paver-patio-replacement-wayne-nj2.webp";
import stoneMasonryTotowa from "@/assets/stone-masonry-totowa-nj.webp";
import paverPatioOutdoorLivingParamus from "@/assets/paver-patio-outdoor-living-paramus-nj.webp";
import paverPatioBluestone from "@/assets/paver-patio-bluestone-steps-paramus-nj.webp";
import drivewayPaversLincolnPark from "@/assets/driveway-pavers-lincoln-park-nj.webp";
import paverPatioParsippany from "@/assets/paver-patio-parsippany-troy-hills-nj.webp";
import outdoorFireplaceEnglewood from "@/assets/outdoor-fireplace-installation-englewood-nj.webp";
import paverPatioPalisadesPark from "@/assets/paver-patio-installation-palisades-park-nj-2.webp";
import patioPaverPalisadesPark from "@/assets/patio-paver-installation-palisades-park-nj.webp";
import patioFirePitPineBrook from "@/assets/patio-fire-pit-pine-brook-nj.webp";
import paverPatioMontvilleTownship from "@/assets/paver-patio-installation-montville-township-nj.webp";
import newPaverPatioOutdoorKitchenParamus from "@/assets/new-paver-patio-outdoor-kitchen-paramus-nj.webp";
import paverPatioPomptonLakes from "@/assets/paver-patio-installation-pompton-lakes-nj-2.webp";
import patioPaverParamus2 from "@/assets/patio-paver-installation-paramus-nj-2.webp";
import patioPaverRutherford from "@/assets/patio-paver-installation-rutherford-nj.webp";

// NEW — Patios
import patioVerona from "@/assets/patio-paver-installation-verona-nj.webp";
import patioClifton from "@/assets/masonry-paver-patio-clifton-nj-2.webp";
import patioMountainLakes from "@/assets/patio-pavers-mountain-lakes-morris-county-nj-3.webp";

import patioTotowa from "@/assets/paver-patio-repair-totowa-passaic-county-new-jersey-2.webp";
import patioMorrisCounty from "@/assets/paver-patio-installation-morris-county-nj-2.webp";

// NEW — Steps
import brickStepsPomptonLakes from "@/assets/brick-masonry-steps-pompton-lakes-nj.webp";
import stoneStepsVerona from "@/assets/stone-masonry-steps-verona-essex-county-nj-3.webp";

import stoneStepsWayne from "@/assets/stone-masonry-steps-wayne-passaic-county-nj.webp";
import stoneStepsFranklinLakes from "@/assets/stone-steps-masonry-franklin-lakes-nj.webp";
import stoneVeneerStepsWayne from "@/assets/stone-veneer-steps-installation-wayne-nj-2.webp";
import masonryStairsNutley from "@/assets/masonry-stairs-retaining-wall-nutley-nj.webp";

// NEW — Retaining Walls
import retainingWallBloomfield from "@/assets/retaining-wall-bloomfield-essex-county-nj.webp";
import retainingWallHackensack from "@/assets/retaining-wall-hackensack-bergen-county-nj.webp";

import retainingWallStepsWayne from "@/assets/retaining-wall-steps-wayne-passaic-county-nj.webp";

import retainingWallWallington from "@/assets/retaining-wall-wallington-bergen-county-nj.webp";

import retainingWallFranklinLakesMasonry from "@/assets/masonry-pro-stone-retaining-wall-franklin-lakes-nj.webp";

// NEW — Driveways
import paverDrivewayCedarGrove from "@/assets/driveways/paver-driveway-installation-cedar-grove-nj-2.webp";
import paverDrivewayParamus from "@/assets/driveways/paver-driveway-paramus-bergen-county-nj.webp";
import concreteDrivewayLincolnPark from "@/assets/concrete-driveway-lincoln-park-nj.webp";
import customMasonryDrivewayCedarGrove from "@/assets/custom-masonry-driveway-cedar-grove-nj.webp";


// NEW — Walkways
import walkwayNorthCaldwell from "@/assets/walkways/paver-walkway-steps-installation-north-caldwell-nj-2.webp";
import walkwayPineBrook from "@/assets/walkways/paver-walkway-installation-pine-brook-nj-2.webp";
import walkwayPalisadesPark from "@/assets/walkways/paver-walkway-install-palisades-park-bergen-county-nj.webp";


// NEW — Outdoor Kitchens
import outdoorKitchenTotowa from "@/assets/outdoor-kitchen-installation-totowa-nj.webp";
import outdoorKitchenTotowa2 from "@/assets/outdoor-kitchen-installation-totowa-nj-2.webp";
import outdoorKitchenPomptonLakes2 from "@/assets/outdoor-kitchen-installation-pompton-lakes-nj-2.webp";
import outdoorKitchenClifton from "@/assets/outdoor-kitchen-richfield-clifton-nj.webp";
import stoopsStepsTotowa from "@/assets/stoops-and-steps-installation-totowa-nj.webp";
import poolPaverPatioBloomfield from "@/assets/gallery/pool-paver-patio-installation-bloomfield-nj.webp";

// NEW — Fireplaces & Fire Pits
import firePitClifton from "@/assets/fire-pit-clifton-nj.webp";
import firePitNorthCaldwell2 from "@/assets/fire-pit-installation-north-caldwell-nj-2.webp";
import fireplaceMahwah2 from "@/assets/fireplace-installation-mahwah-nj-hero-2.webp";


// NEW — Stone Masonry
import stoneMasonryOakland2 from "@/assets/stone-masonry-installation-oakland-nj-3.webp";

import brickWorkNorthCaldwell from "@/assets/brick-work-north-caldwell-essex-county-nj.webp";

// NEW — Concrete
import concreteDrivewayLincolnPark2 from "@/assets/concrete-driveway-lincoln-park-nj-2.webp";
import stampedConcreteOrange from "@/assets/stamped-concrete-orange-essex-county-nj.webp";
import concreteSidewalkTotowa from "@/assets/concrete-sidewalk-lawn-installation-totowa-nj.webp";

// NEW — Services directory
import franklinLakesStoneMasonry from "@/assets/services/stone-masonry-installation-franklin-lakes-nj.webp";
import wayneRetainingWall from "@/assets/services/retaining-wall-installation-wayne-nj.webp";

import newMilfordSteps from "@/assets/services/masonry-steps-installation-new-milford-nj.webp";

import paverWalkwayFairfield from "@/assets/paver-walkways-installation-fairfield-nj.webp";
import paverPatioOradell from "@/assets/paver-patio-installation-oradell-nj.webp";
import montclairOutdoorKitchen from "@/assets/services/outdoor-kitchen-installation-montclair-nj.webp";
import nutleyCustomMasonry from "@/assets/services/custom-masonry-nutley-essex-county-new-jersey.webp";
import westwoodPaverPatio from "@/assets/services/paver-patio-installation-westwood-nj.webp";
import montvilleWalkway from "@/assets/services/paver-walkway-installation-montville-township-nj.webp";
import pomptonLakesConcreteDriveway from "@/assets/services/concrete-driveway-installation-pompton-lakes-nj.webp";
import nutleyRetainingWall2 from "@/assets/retaining-wall-installation-nutley-nj-2.webp";
import westMilfordStampedConcrete from "@/assets/services/stamped-concrete-installation-west-milford-nj.webp";


// NEW — Morris County general

import pomptonPlainsPavers2 from "@/assets/morris-county-masonry-pavers-pompton-plains-nj-2.webp";
import paversInstallationMorris from "@/assets/pavers-installation-morris-county-nj.webp";

// NEW — Additional
import stampedConcreteVsPaversTotowa from "@/assets/stamped-concrete-vs-pavers-totowa-nj.webp";
import brickWorkStairsWayne from "@/assets/brick-work-masonry-stairs-wayne-nj-hero.webp";

// NEW — March 2026
import patioWestOrangePool from "@/assets/patio-paver-installation-west-orange-nj-pool.webp";
import stoneMasonryMaywood from "@/assets/stone-masonry-maywood-nj.webp";
import patioFirePitEssexFells from "@/assets/patio-paver-fire-pit-essex-fells-nj.webp";
import stoneVeneerWestCaldwell from "@/assets/stone-veneer-west-caldwell-nj.webp";
import poolPatioRidgewood from "@/assets/pool-paver-patio-installation-ridgewood-nj.webp";
import paverPatioRidgewood from "@/assets/paver-patio-installation-ridgewood-nj.webp";
import paverPatioMontclair2 from "@/assets/paver-patio-installation-montclair-nj-2.webp";
import patioTeaneck from "@/assets/patio-paver-installation-teaneck-nj.webp";

// NEW — March 2026 batch 2
import stoneVeneerPassaic from "@/assets/stone-veneer-passaic-nj.webp";
import retainingWallHackensack2 from "@/assets/retaining-wall-hackensack-nj.webp";
import paverPatioNewark from "@/assets/paver-patio-installation-newark-nj.webp";
import paverPatioBloomfield2 from "@/assets/paver-patio-installation-bloomfield-nj.webp";
import patioEssexFells2 from "@/assets/patio-paver-installation-essex-fells-nj-2.webp";
import stoneVeneerWestCaldwell2 from "@/assets/stone-veneer-installation-west-caldwell-nj.webp";
import poolPatioRidgewood2 from "@/assets/pool-patio-pavers-installation-ridgewood-nj.webp";
import masonryProWayne from "@/assets/masonry-pro-construction-wayne-nj.webp";

// NEW — March 2026 batch 3
import paverDrivewayClifton from "@/assets/paver-driveway-clifton-nj.webp";
import poolPatioWayne from "@/assets/paver-pool-patio-installation-wayne-nj.webp";
import newPatioCedarGrove from "@/assets/new-paver-patio-cedar-grove-nj.webp";
import paverPatioWayne2 from "@/assets/paver-patio-installation-wayne-nj-2.webp";

// NEW — March 2026 batch 4
import outdoorKitchenFairLawn from "@/assets/outdoor-kitchen-fair-lawn-nj.webp";
import retainingWallParamus from "@/assets/breezewood-retaining-wall-installation-paramus-nj.webp";
import paverPatioBergenfield from "@/assets/paver-patio-installation-bergenfield-nj.webp";
import stonePaverPatioLittleFalls from "@/assets/stone-paver-patio-little-falls-nj.webp";
import paverPatioWoodlandPark from "@/assets/paver-patio-installation-woodland-park-nj.webp";
import paverPatioWayne3 from "@/assets/paver-patio-installation-wayne-nj-3.webp";
import patioTotowa2 from "@/assets/patio-installation-totowa-nj.webp";
import patioFirePitVerona from "@/assets/patio-fire-pit-verona-nj.webp";

import firePitEssexFells2 from "@/assets/fire-pit-installation-essex-fells-nj-2.webp";

// NEW — March 2026 batch 5
import paverPatioNutley2 from "@/assets/paver-patio-installation-nutley-nj-2.webp";
import paverPatioMontclair3 from "@/assets/paver-patio-montclair-nj.webp";
import paverPatioFairLawn from "@/assets/paver-patio-installation-fair-lawn-nj.webp";
import retainingWallUpperMontclair from "@/assets/retaining-wall-installation-upper-montclair-nj.webp";
import paverPatioMontclair4 from "@/assets/paver-patio-installation-montclair-nj-2.webp";
import paverWalkwayRutherford from "@/assets/paver-walkway-rutherford-nj.webp";
import paverPatioLittleFerry from "@/assets/paver-patio-installation-little-ferry-nj.webp";
import masonryStairsCedarGrove from "@/assets/masonry-stairs-install-cedar-grove-nj.webp";
import paperPatioPequannock from "@/assets/paper-patio-installation-pequannock-nj.webp";

export interface GalleryProject {
  image: string;
  title: string;
  location: string;
  alt: string;
  lat: number;
  lng: number;
}

export const finishedProjects: GalleryProject[] = [
  // ─── NEW: Pequannock Township, Morris County ───
  {
    image: paperPatioPequannock,
    title: "Paver Patio with Gazebo Installation",
    location: "Pequannock Township, Morris County, NJ",
    alt: "New paver patio installation with a gazebo and outdoor furniture in Pequannock Township, Morris County, NJ. Masonry Pro Construction",
    lat: 40.964717,
    lng: -74.30185,
  },
  // ─── EXISTING 34 ───
  {
    image: halfCourtNorthCaldwell,
    title: "Custom Masonry Half-Court",
    location: "North Caldwell, Essex County, NJ",
    alt: "Custom concrete and masonry basketball half-court installation with paver border at a residential backyard in North Caldwell, Essex County, New Jersey by Masonry Pro Construction.",
    lat: 40.853517,
    lng: -74.256478,
  },
  {
    image: outdoorKitchenNorthHaledon,
    title: "Custom Outdoor Kitchen & Pizza Oven",
    location: "North Haledon, Passaic County, NJ",
    alt: "Custom outdoor kitchen with stone pizza oven, paver patio, and masonry steps completed at a residential property in North Haledon, Passaic County, New Jersey by Masonry Pro Construction.",
    lat: 40.978353,
    lng: -74.199834,
  },
  {
    image: patioNorthHaledonPassaic,
    title: "Patio Paver Installation",
    location: "North Haledon, Passaic County, NJ",
    alt: "Newly installed patio pavers with outdoor kitchen, lighting, and steps in North Haledon, Passaic County, NJ, by Masonry Pro",
    lat: 40.978353,
    lng: -74.199834,
  },
  {
    image: retainingWallConstructionTotowa,
    title: "Retaining Wall Construction",
    location: "Totowa, Passaic County, NJ",
    alt: "Retaining wall construction at a residential property in Totowa, Passaic County, NJ by Masonry Pro Construction.",
    lat: 40.9059,
    lng: -74.2163,
  },
  {
    image: paverPatioNorthHaledon,
    title: "Paver Patio Installation",
    location: "North Haledon, Passaic County, NJ",
    alt: "Completed paver patio installation at a residential property in North Haledon, Passaic County, New Jersey by Masonry Pro Construction.",
    lat: 40.978353,
    lng: -74.199834,
  },
  {
    image: paverPatioKinnelon,
    title: "Poolside Paver Patio",
    location: "Kinnelon, Morris County, NJ",
    alt: "Finished paver patio surrounding an inground pool at a home in Kinnelon, Morris County, New Jersey by Masonry Pro Construction.",
    lat: 41.0158,
    lng: -74.3681,
  },
  {
    image: retainingWallNutley,
    title: "Stone Retaining Wall",
    location: "Nutley, Essex County, NJ",
    alt: "Completed stone retaining wall installation at a residential property in Nutley, Essex County, New Jersey by Masonry Pro Construction.",
    lat: 40.8223,
    lng: -74.1599,
  },
  {
    image: stoneMasonryOakland,
    title: "Stone Masonry Installation",
    location: "Oakland, Bergen County, NJ",
    alt: "Finished stone masonry installation on a home exterior in Oakland, Bergen County, New Jersey by Masonry Pro Construction.",
    lat: 41.0134,
    lng: -74.2365,
  },
  {
    image: outdoorKitchenPomptonLakes,
    title: "Outdoor Kitchen",
    location: "Pompton Lakes, Passaic County, NJ",
    alt: "Custom outdoor kitchen with built-in grill and stone countertops completed in Pompton Lakes, Passaic County, New Jersey.",
    lat: 41.0054,
    lng: -74.2907,
  },
  {
    image: fireplaceMahwah,
    title: "Outdoor Fireplace",
    location: "Mahwah, Bergen County, NJ",
    alt: "Stone outdoor fireplace installation completed at a residential backyard in Mahwah, Bergen County, New Jersey.",
    lat: 41.0887,
    lng: -74.1438,
  },
  {
    image: patioLivingston,
    title: "Paver Patio",
    location: "Livingston, Essex County, NJ",
    alt: "Finished paver patio installation with decorative border at a home in Livingston, Essex County, New Jersey.",
    lat: 40.7909,
    lng: -74.3150,
  },
  {
    image: walkwayBloomfield,
    title: "Masonry Walkway",
    location: "Bloomfield, Essex County, NJ",
    alt: "Completed masonry walkway with paver stones leading to the front entrance of a home in Bloomfield, Essex County, New Jersey.",
    lat: 40.8068,
    lng: -74.1854,
  },
  {
    image: retainingWallWestOrange,
    title: "Retaining Wall",
    location: "West Orange, Essex County, NJ",
    alt: "Completed retaining wall installation at a residential property in West Orange, Essex County, New Jersey by Masonry Pro Construction.",
    lat: 40.7987,
    lng: -74.2390,
  },
  {
    image: stepsStoopsWayne,
    title: "Steps & Stoops Installation",
    location: "Wayne, Passaic County, NJ",
    alt: "New steps and stoops installation by Masonry Pro Construction at residence in Wayne, Passaic County, NJ.",
    lat: 40.9241666666666,
    lng: -74.2564166666666,
  },
  {
    image: patioDenville,
    title: "Paver Patio",
    location: "Denville, Morris County, NJ",
    alt: "Finished paver patio installation with seating area at a residential backyard in Denville, Morris County, New Jersey.",
    lat: 40.8923,
    lng: -74.4774,
  },
  {
    image: brickStepsTotowa,
    title: "Brick Masonry Steps",
    location: "Totowa, Passaic County, NJ",
    alt: "Completed brick masonry front steps and landing at a home in Totowa, Passaic County, New Jersey.",
    lat: 40.9048,
    lng: -74.2237,
  },
  {
    image: sidewalkWayne,
    title: "Concrete Sidewalk",
    location: "Wayne, Passaic County, NJ",
    alt: "Finished concrete sidewalk installation along a residential property in Wayne, Passaic County, New Jersey.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: firePitNorthCaldwell,
    title: "Fire Pit Installation",
    location: "North Caldwell, Essex County, NJ",
    alt: "Custom stone fire pit completed in a backyard outdoor living space in North Caldwell, Essex County, New Jersey.",
    lat: 40.8535,
    lng: -74.2565,
  },
  {
    image: stoneStepsMontclair,
    title: "Stone Masonry Steps",
    location: "Montclair, Essex County, NJ",
    alt: "Finished natural stone masonry steps and walkway at a residential property in Montclair, Essex County, New Jersey.",
    lat: 40.8259,
    lng: -74.2090,
  },
  {
    image: retainingWallMorrisTownship,
    title: "Retaining Wall",
    location: "Morris Township, Morris County, NJ",
    alt: "Completed block retaining wall providing yard leveling and erosion control in Morris Township, Morris County, New Jersey.",
    lat: 40.7965,
    lng: -74.4816,
  },
  {
    image: drivewayLeonia,
    title: "Paver Driveway",
    location: "Leonia, Bergen County, NJ",
    alt: "Finished paver driveway installation at a residential home in Leonia, Bergen County, New Jersey by Masonry Pro Construction.",
    lat: 40.8613,
    lng: -73.9887,
  },
  {
    image: patioWallClifton,
    title: "Paver Patio & Masonry Wall",
    location: "Clifton, Passaic County, NJ",
    alt: "Completed paver patio with decorative masonry sitting wall at a backyard in Clifton, Passaic County, New Jersey.",
    lat: 40.8584,
    lng: -74.1638,
  },
  {
    image: stoneWallStepsFranklinLakes,
    title: "Stone Wall & Steps",
    location: "Franklin Lakes, Bergen County, NJ",
    alt: "Finished stone retaining wall with integrated stone steps at a hillside property in Franklin Lakes, Bergen County, New Jersey.",
    lat: 41.0165,
    lng: -74.2057,
  },
  {
    image: outdoorKitchenMontclair,
    title: "Outdoor Kitchen",
    location: "Montclair, Essex County, NJ",
    alt: "Custom outdoor kitchen installation with stone veneer and countertops at a home in Montclair, Essex County, New Jersey.",
    lat: 40.8259,
    lng: -74.2090,
  },
  {
    image: retainingWallNutley2,
    title: "Retaining Wall Installation",
    location: "Nutley, Essex County, NJ",
    alt: "New retaining wall installation with stone steps in front of a residential home in Nutley, NJ, by Masonry Pro Construction.",
    lat: 40.814819,
    lng: -74.153572,
  },
  {
    image: retainingWallOldTappan,
    title: "Retaining Wall Hardscape",
    location: "Old Tappan, Bergen County, NJ",
    alt: "Tiered retaining wall hardscape with steps and landscaping in Old Tappan, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 41.013131,
    lng: -73.991609,
  },
  {
    image: firePitEssexFells,
    title: "Fire Pit Installation",
    location: "Essex Fells, Essex County, NJ",
    alt: "Newly installed block fire pit on a paver patio in Essex Fells, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.827356,
    lng: -74.265786,
  },
  {
    image: firePitNorthHaledon,
    title: "Fire Pit Installation",
    location: "North Haledon, Passaic County, NJ",
    alt: "New fire pit installation with stone patio pavers in North Haledon, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.977842,
    lng: -74.198403,
  },
  {
    image: stepsTotowa2,
    title: "Masonry Steps Installation",
    location: "Totowa, Passaic County, NJ",
    alt: "New masonry steps with integrated lighting for a home in Totowa, Passaic County, NJ.",
    lat: 40.905923,
    lng: -74.216289,
  },
  {
    image: stepsNorthHaledon,
    title: "Masonry Brick Steps Installation",
    location: "North Haledon, Passaic County, NJ",
    alt: "Newly installed masonry brick steps leading to a residence in North Haledon, Passaic County, NJ.",
    lat: 40.959298,
    lng: -74.177726,
  },
  {
    image: paverPatioBloomfield,
    title: "Paver Patio Installation",
    location: "Bloomfield, Essex County, NJ",
    alt: "Paver patio with an integrated fire pit and seating in Bloomfield, Essex County, NJ. by Masonry Pro Construction",
    lat: 40.796196,
    lng: -74.185017,
  },
  {
    image: bluestonePatioHackensack,
    title: "Bluestone Patio with Brick Veneer Wall",
    location: "Hackensack, Bergen County, NJ",
    alt: "Newly installed bluestone patio with a brick veneer wall in Hackensack, Bergen County, NJ, by Masonry Pro",
    lat: 40.881852,
    lng: -74.057894,
  },
  {
    image: paverPatioFirePitCloster,
    title: "Paver Patio with Fire Pit & Knee Wall",
    location: "Closter, Bergen County, NJ",
    alt: "Newly installed paver patio with fire pit and knee wall lighting in Closter, Bergen County, NJ, by Masonry Pro",
    lat: 40.979347,
    lng: -73.953137,
  },
  {
    image: stoneMasonryCaldwell,
    title: "Natural Stone Pillar Construction",
    location: "Caldwell, Essex County, NJ",
    alt: "Masonry pro construction truck parked by a recently constructed natural stone pillar in Caldwell, Essex County, NJ.",
    lat: 40.842272,
    lng: -74.278843,
  },
  // ─── NEW: Patios ───
  {
    image: patioVerona,
    title: "Paver Patio Installation",
    location: "Verona, Essex County, NJ",
    alt: "Newly installed paver patio at a residential backyard in Verona, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8357,
    lng: -74.2407,
  },
  {
    image: patioClifton,
    title: "Paver Patio",
    location: "Clifton, Passaic County, NJ",
    alt: "Completed masonry paver patio installation at a home in Clifton, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.8584,
    lng: -74.1638,
  },
  {
    image: patioMountainLakes,
    title: "Patio Pavers",
    location: "Mountain Lakes, Morris County, NJ",
    alt: "Finished patio paver installation at a residential property in Mountain Lakes, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.8915,
    lng: -74.4326,
  },
  {
    image: patioTotowa,
    title: "Paver Patio",
    location: "Totowa, Passaic County, NJ",
    alt: "Finished paver patio at a residential home in Totowa, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9048,
    lng: -74.2237,
  },
  {
    image: patioMorrisCounty,
    title: "Paver Patio Installation",
    location: "Morris County, NJ",
    alt: "Completed paver patio installation at a home in Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.8623,
    lng: -74.5441,
  },
  // ─── NEW: Steps ───
  {
    image: brickStepsPomptonLakes,
    title: "Brick Masonry Steps",
    location: "Pompton Lakes, Passaic County, NJ",
    alt: "Completed brick masonry front steps at a home in Pompton Lakes, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 41.0054,
    lng: -74.2907,
  },
  {
    image: stoneStepsVerona,
    title: "Stone Masonry Steps",
    location: "Verona, Essex County, NJ",
    alt: "Finished stone masonry steps installation at a residential property in Verona, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8357,
    lng: -74.2407,
  },
  {
    image: stoneStepsWayne,
    title: "Stone Masonry Steps",
    location: "Wayne, Passaic County, NJ",
    alt: "Completed stone masonry steps at a residential property in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: stoneStepsFranklinLakes,
    title: "Stone Steps",
    location: "Franklin Lakes, Bergen County, NJ",
    alt: "Finished stone masonry steps at a hillside home in Franklin Lakes, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 41.0165,
    lng: -74.2057,
  },
  {
    image: stoneVeneerStepsWayne,
    title: "Stone Veneer Steps",
    location: "Wayne, Passaic County, NJ",
    alt: "Newly installed stone veneer steps at a residential home in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: masonryStairsNutley,
    title: "Masonry Stairs & Retaining Wall",
    location: "Nutley, Essex County, NJ",
    alt: "Completed masonry stairs with retaining wall at a residential property in Nutley, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8223,
    lng: -74.1599,
  },
  {
    image: brickWorkStairsWayne,
    title: "Brick Work Masonry Stairs",
    location: "Wayne, Passaic County, NJ",
    alt: "Completed brick masonry stairs at a residential property in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  // ─── NEW: Retaining Walls ───
  {
    image: retainingWallBloomfield,
    title: "Retaining Wall",
    location: "Bloomfield, Essex County, NJ",
    alt: "Completed retaining wall installation at a residential property in Bloomfield, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8068,
    lng: -74.1854,
  },
  {
    image: retainingWallHackensack,
    title: "Retaining Wall",
    location: "Hackensack, Bergen County, NJ",
    alt: "Finished retaining wall installation at a property in Hackensack, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8819,
    lng: -74.0579,
  },
  {
    image: retainingWallStepsWayne,
    title: "Retaining Wall & Steps",
    location: "Wayne, Passaic County, NJ",
    alt: "Completed retaining wall with integrated steps at a home in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: retainingWallWallington,
    title: "Retaining Wall",
    location: "Wallington, Bergen County, NJ",
    alt: "Completed retaining wall installation at a home in Wallington, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8534,
    lng: -74.1057,
  },
  {
    image: retainingWallFranklinLakesMasonry,
    title: "Stone Retaining Wall",
    location: "Franklin Lakes, Bergen County, NJ",
    alt: "Completed stone retaining wall by Masonry Pro Construction at a home in Franklin Lakes, Bergen County, NJ.",
    lat: 41.0165,
    lng: -74.2057,
  },
  // ─── NEW: Driveways ───
  {
    image: paverDrivewayCedarGrove,
    title: "Paver Driveway Installation",
    location: "Cedar Grove, Essex County, NJ",
    alt: "Completed paver driveway installation at a home in Cedar Grove, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8518,
    lng: -74.2290,
  },
  {
    image: paverDrivewayParamus,
    title: "Paver Driveway",
    location: "Paramus, Bergen County, NJ",
    alt: "Finished paver driveway at a residential home in Paramus, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9445,
    lng: -74.0705,
  },
  {
    image: concreteDrivewayLincolnPark,
    title: "Concrete Driveway",
    location: "Lincoln Park, Morris County, NJ",
    alt: "Completed concrete driveway installation at a home in Lincoln Park, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.9243,
    lng: -74.3021,
  },
  // ─── NEW: Walkways ───
  {
    image: walkwayNorthCaldwell,
    title: "Paver Walkway & Steps",
    location: "North Caldwell, Essex County, NJ",
    alt: "Completed paver walkway and steps installation at a home in North Caldwell, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8535,
    lng: -74.2565,
  },
  {
    image: walkwayPineBrook,
    title: "Paver Walkway",
    location: "Pine Brook, Morris County, NJ",
    alt: "Finished paver walkway at a residential property in Pine Brook, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.8718,
    lng: -74.3469,
  },
  {
    image: walkwayPalisadesPark,
    title: "Paver Walkway",
    location: "Palisades Park, Bergen County, NJ",
    alt: "Completed paver walkway installation at a home in Palisades Park, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8482,
    lng: -73.9971,
  },
  // ─── NEW: Outdoor Kitchens ───
  {
    image: outdoorKitchenTotowa,
    title: "Outdoor Kitchen Installation",
    location: "Totowa, Passaic County, NJ",
    alt: "Completed outdoor kitchen installation at a home in Totowa, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9048,
    lng: -74.2237,
  },
  {
    image: outdoorKitchenTotowa2,
    title: "Outdoor Kitchen",
    location: "Totowa, Passaic County, NJ",
    alt: "Custom outdoor kitchen with countertops at a backyard in Totowa, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9048,
    lng: -74.2237,
  },
  {
    image: outdoorKitchenPomptonLakes2,
    title: "Outdoor Kitchen",
    location: "Pompton Lakes, Passaic County, NJ",
    alt: "Finished outdoor kitchen installation at a home in Pompton Lakes, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 41.0054,
    lng: -74.2907,
  },
  {
    image: outdoorKitchenClifton,
    title: "Outdoor Kitchen",
    location: "Clifton, Passaic County, NJ",
    alt: "Completed outdoor kitchen with built-in grill at a property in Clifton, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.8584,
    lng: -74.1638,
  },
  {
    image: customMasonryDrivewayCedarGrove,
    title: "Custom Masonry Driveway",
    location: "Cedar Grove, Essex County, NJ",
    alt: "Custom masonry driveway completed at a residential property in Cedar Grove, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8518,
    lng: -74.2290,
  },
  // ─── NEW: Fireplaces & Fire Pits ───
  {
    image: firePitClifton,
    title: "Fire Pit",
    location: "Clifton, Passaic County, NJ",
    alt: "Completed fire pit installation at a backyard in Clifton, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.8584,
    lng: -74.1638,
  },
  {
    image: firePitNorthCaldwell2,
    title: "Fire Pit",
    location: "North Caldwell, Essex County, NJ",
    alt: "Custom fire pit installation at a residential property in North Caldwell, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8535,
    lng: -74.2565,
  },
  {
    image: fireplaceMahwah2,
    title: "Outdoor Fireplace",
    location: "Mahwah, Bergen County, NJ",
    alt: "Completed stone outdoor fireplace at a home in Mahwah, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 41.0887,
    lng: -74.1438,
  },
  // ─── NEW: Stone Masonry ───
  {
    image: stoneMasonryOakland2,
    title: "Stone Masonry",
    location: "Oakland, Bergen County, NJ",
    alt: "Completed stone masonry installation on a home exterior in Oakland, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 41.0134,
    lng: -74.2365,
  },
  {
    image: brickWorkNorthCaldwell,
    title: "Brick Work",
    location: "North Caldwell, Essex County, NJ",
    alt: "Completed brick work at a residential property in North Caldwell, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8535,
    lng: -74.2565,
  },
  // ─── NEW: Concrete ───
  {
    image: concreteDrivewayLincolnPark2,
    title: "Concrete Driveway",
    location: "Lincoln Park, Morris County, NJ",
    alt: "Finished concrete driveway at a home in Lincoln Park, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.9243,
    lng: -74.3021,
  },
  {
    image: stampedConcreteOrange,
    title: "Stamped Concrete",
    location: "Orange, Essex County, NJ",
    alt: "Completed stamped concrete installation at a property in Orange, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.7706,
    lng: -74.2327,
  },
  {
    image: concreteSidewalkTotowa,
    title: "Concrete Sidewalk & Lawn",
    location: "Totowa, Passaic County, NJ",
    alt: "Finished concrete sidewalk and lawn installation at a home in Totowa, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9048,
    lng: -74.2237,
  },
  // ─── NEW: Services directory images ───
  {
    image: franklinLakesStoneMasonry,
    title: "Stone Masonry Installation",
    location: "Franklin Lakes, Bergen County, NJ",
    alt: "Completed stone masonry installation at a home in Franklin Lakes, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 41.0165,
    lng: -74.2057,
  },
  {
    image: wayneRetainingWall,
    title: "Retaining Wall Installation",
    location: "Wayne, Passaic County, NJ",
    alt: "Completed retaining wall installation at a residential property in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: newMilfordSteps,
    title: "Masonry Steps Installation",
    location: "New Milford, Bergen County, NJ",
    alt: "Completed masonry steps installation at a home in New Milford, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9354,
    lng: -74.0190,
  },
  {
    image: montclairOutdoorKitchen,
    title: "Outdoor Kitchen Installation",
    location: "Montclair, Essex County, NJ",
    alt: "Completed outdoor kitchen installation at a home in Montclair, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8259,
    lng: -74.2090,
  },
  {
    image: nutleyCustomMasonry,
    title: "Custom Masonry",
    location: "Nutley, Essex County, NJ",
    alt: "Finished custom masonry work at a residential property in Nutley, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8223,
    lng: -74.1599,
  },
  {
    image: westwoodPaverPatio,
    title: "Paver Patio Installation",
    location: "Westwood, Bergen County, NJ",
    alt: "Completed paver patio installation at a home in Westwood, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9912,
    lng: -74.0320,
  },
  {
    image: montvilleWalkway,
    title: "Paver Walkway Installation",
    location: "Montville Township, Morris County, NJ",
    alt: "Finished paver walkway installation at a home in Montville Township, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.9225,
    lng: -74.3583,
  },
  {
    image: pomptonLakesConcreteDriveway,
    title: "Concrete Driveway Installation",
    location: "Pompton Lakes, Passaic County, NJ",
    alt: "Completed concrete driveway installation at a home in Pompton Lakes, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 41.0054,
    lng: -74.2907,
  },
  {
    image: nutleyRetainingWall2,
    title: "Retaining Wall Installation",
    location: "Nutley, Essex County, NJ",
    alt: "Retaining wall installation at a residential property in Nutley, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8223,
    lng: -74.1599,
  },
  {
    image: westMilfordStampedConcrete,
    title: "Stamped Concrete Installation",
    location: "West Milford, Passaic County, NJ",
    alt: "Completed stamped concrete installation at a property in West Milford, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 41.1284,
    lng: -74.3671,
  },
  // ─── NEW: Morris County general ───
  {
    image: pomptonPlainsPavers2,
    title: "Paver Installation",
    location: "Pompton Plains, Morris County, NJ",
    alt: "Finished paver installation at a residential property in Pompton Plains, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.9651,
    lng: -74.3044,
  },
  {
    image: paversInstallationMorris,
    title: "Pavers Installation",
    location: "Morris County, NJ",
    alt: "Completed pavers installation at a property in Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.8623,
    lng: -74.5441,
  },
  {
    image: paverWalkwayFairfield,
    title: "Paver Walkway Installation",
    location: "Fairfield, Essex County, NJ",
    alt: "Completed paver walkway installation with decorative border at a residential backyard in Fairfield, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8826,
    lng: -74.3065,
  },
  {
    image: paverPatioOradell,
    title: "Paver Patio Installation",
    location: "Oradell, Bergen County, NJ",
    alt: "Aerial view of a completed paver patio installation with built-in grill area at a home in Oradell, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9576,
    lng: -74.0368,
  },
  {
    image: paverWalkwayWayne2,
    title: "Paver Walkway Installation",
    location: "Wayne, Passaic County, NJ",
    alt: "Curved paver walkway installation with matching steps at a residential home in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: paverPatioReplacementWayne2,
    title: "Paver Patio Replacement",
    location: "Wayne, Passaic County, NJ",
    alt: "Large backyard paver patio replacement at a home in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: stoneMasonryTotowa,
    title: "Stone Masonry",
    location: "Totowa, Passaic County, NJ",
    alt: "Natural stone masonry wall and steps at a residential property in Totowa, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9059,
    lng: -74.2163,
  },
  {
    image: paverPatioOutdoorLivingParamus,
    title: "Paver Patio & Fire Pit",
    location: "Paramus, Bergen County, NJ",
    alt: "Paver patio outdoor living area with fire pit and seating in Paramus, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9445,
    lng: -74.0712,
  },
  {
    image: paverPatioBluestone,
    title: "Paver Patio & Bluestone Steps",
    location: "Paramus, Bergen County, NJ",
    alt: "Elevated paver patio with bluestone steps and outdoor furniture in Paramus, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9445,
    lng: -74.0712,
  },
  {
    image: drivewayPaversLincolnPark,
    title: "Driveway Paver Installation",
    location: "Lincoln Park, Morris County, NJ",
    alt: "Luxury paver driveway installation at a modern home in Lincoln Park, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.9243,
    lng: -74.3021,
  },
  {
    image: paverPatioParsippany,
    title: "Paver Patio & Pool Deck",
    location: "Parsippany-Troy Hills, Morris County, NJ",
    alt: "Paver patio and pool deck with outdoor kitchen gazebo in Parsippany-Troy Hills, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.8578,
    lng: -74.4260,
  },
  {
    image: outdoorFireplaceEnglewood,
    title: "Outdoor Fireplace Installation",
    location: "Englewood, Bergen County, NJ",
    alt: "Custom stone outdoor fireplace installation with wood storage at a property in Englewood, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8929,
    lng: -73.9726,
  },
  {
    image: patioWestOrangePool,
    title: "Patio Paver & Pool Deck Installation",
    location: "West Orange, Essex County, NJ",
    alt: "Paver patio and pool deck installation with landscaping at a residential property in West Orange, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.7987,
    lng: -74.2391,
  },
  {
    image: stoneMasonryMaywood,
    title: "Stone Masonry Wall",
    location: "Maywood, Bergen County, NJ",
    alt: "Stone masonry wall construction at a residential property in Maywood, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9026,
    lng: -74.0618,
  },
  {
    image: patioFirePitEssexFells,
    title: "Patio Paver & Fire Pit Installation",
    location: "Essex Fells, Essex County, NJ",
    alt: "Large paver patio with fire pit and stone steps installation at a home in Essex Fells, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8254,
    lng: -74.2835,
  },
  {
    image: stoneVeneerWestCaldwell,
    title: "Stone Veneer & Paver Porch",
    location: "West Caldwell, Essex County, NJ",
    alt: "Stone veneer facade and paver porch installation at a residential home in West Caldwell, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8398,
    lng: -74.2818,
  },
  {
    image: poolPatioRidgewood,
    title: "Pool Paver Patio Installation",
    location: "Ridgewood, Bergen County, NJ",
    alt: "Paver patio installation around a backyard pool with landscaping in Ridgewood, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9793,
    lng: -74.1168,
  },
  {
    image: paverPatioRidgewood,
    title: "Paver Patio Installation",
    location: "Ridgewood, Bergen County, NJ",
    alt: "Dark paver patio installation with stone steps at a residential property in Ridgewood, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9793,
    lng: -74.1168,
  },
  {
    image: paverPatioMontclair2,
    title: "Pool Paver Patio Installation",
    location: "Montclair, Essex County, NJ",
    alt: "Paver patio installation around a pool at a residential property in Montclair, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8259,
    lng: -74.2090,
  },
  {
    image: patioTeaneck,
    title: "Patio Paver & Retaining Wall",
    location: "Teaneck, Bergen County, NJ",
    alt: "Large paver patio installation with stone retaining wall at a residential property in Teaneck, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8976,
    lng: -74.0159,
  },
  {
    image: paverPatioPalisadesPark,
    title: "Paver Patio & Walkway Installation",
    location: "Palisades Park, Bergen County, NJ",
    alt: "Paver patio and stepping stone walkway installation under a deck at a residential property in Palisades Park, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8482,
    lng: -73.9971,
  },
  {
    image: patioPaverPalisadesPark,
    title: "Patio Paver & Stepping Stone Installation",
    location: "Palisades Park, Bergen County, NJ",
    alt: "Patio paver installation with stepping stone pathway and landscaping at a home in Palisades Park, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8482,
    lng: -73.9971,
  },
  {
    image: patioFirePitPineBrook,
    title: "Patio & Fire Pit Installation",
    location: "Pine Brook, Morris County, NJ",
    alt: "Paver patio with square fire pit and seating wall installation in a backyard in Pine Brook, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.8715,
    lng: -74.3468,
  },
  {
    image: paverPatioMontvilleTownship,
    title: "Herringbone Paver Patio Detail",
    location: "Montville Township, Morris County, NJ",
    alt: "Close-up of herringbone paver patio pattern with dark border at a residential property in Montville Township, Morris County, NJ, by Masonry Pro Construction.",
    lat: 40.9226,
    lng: -74.3627,
  },
  {
    image: newPaverPatioOutdoorKitchenParamus,
    title: "Paver Patio & Outdoor Kitchen",
    location: "Paramus, Bergen County, NJ",
    alt: "Paver patio with outdoor kitchen, stone steps with LED lighting at a home in Paramus, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9445,
    lng: -74.0754,
  },
  {
    image: paverPatioPomptonLakes,
    title: "Paver Patio & Stone Wall Installation",
    location: "Pompton Lakes, Passaic County, NJ",
    alt: "Paver patio installation with stone veneer retaining wall at a residential property in Pompton Lakes, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 41.0054,
    lng: -74.2907,
  },
  {
    image: patioPaverParamus2,
    title: "Luxury Paver Patio & Outdoor Living",
    location: "Paramus, Bergen County, NJ",
    alt: "Large luxury paver patio with outdoor dining, seating areas, and stone pillars at a home in Paramus, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9445,
    lng: -74.0754,
  },
  {
    image: patioPaverRutherford,
    title: "Patio Paver Installation",
    location: "Rutherford, Bergen County, NJ",
    alt: "Paver patio installation with dark border next to a home in Rutherford, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8265,
    lng: -74.1068,
  },
  {
    image: stoneVeneerPassaic,
    title: "Stone Veneer Installation",
    location: "Passaic, Passaic County, NJ",
    alt: "Stone veneer siding installation on a residential home with landscaping in Passaic, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.8568,
    lng: -74.1285,
  },
  {
    image: retainingWallHackensack2,
    title: "Retaining Wall Installation",
    location: "Hackensack, Bergen County, NJ",
    alt: "Multi-level stone retaining wall with steps built in a residential backyard in Hackensack, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8859,
    lng: -74.0435,
  },
  {
    image: paverPatioNewark,
    title: "Paver Patio Installation",
    location: "Newark, Essex County, NJ",
    alt: "Herringbone pattern paver patio with dark border and stone planter wall installed at a home in Newark, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.7357,
    lng: -74.1724,
  },
  {
    image: paverPatioBloomfield2,
    title: "Paver Patio Installation",
    location: "Bloomfield, Essex County, NJ",
    alt: "New paver patio with dark border installed behind a white residential home in Bloomfield, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.7968,
    lng: -74.1855,
  },
  {
    image: patioEssexFells2,
    title: "Patio Paver & Steps Installation",
    location: "Essex Fells, Essex County, NJ",
    alt: "Paver patio with stone-faced steps leading to a back door at a home in Essex Fells, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8254,
    lng: -74.2846,
  },
  {
    image: stoneVeneerWestCaldwell2,
    title: "Stone Veneer Installation",
    location: "West Caldwell, Essex County, NJ",
    alt: "Natural stone veneer installation on a home front entrance with an octagonal window in West Caldwell, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8398,
    lng: -74.2818,
  },
  {
    image: poolPatioRidgewood2,
    title: "Pool Patio Paver Installation",
    location: "Ridgewood, Bergen County, NJ",
    alt: "Paver patio surrounding an in-ground pool with lounge furniture in Ridgewood, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9793,
    lng: -74.1166,
  },
  {
    image: masonryProWayne,
    title: "Stone Veneer Installation",
    location: "Wayne, Passaic County, NJ",
    alt: "Masonry Pro Construction worker in front of a completed stone veneer installation at a home in Wayne, Passaic County, NJ.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: paverDrivewayClifton,
    title: "Paver Driveway Installation",
    location: "Clifton, Passaic County, NJ",
    alt: "New paver driveway installation with dark border at a residential home in Clifton, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.8584,
    lng: -74.1638,
  },
  {
    image: poolPatioWayne,
    title: "Pool Patio Paver Installation",
    location: "Wayne, Passaic County, NJ",
    alt: "Paver patio installed around an in-ground pool next to a deck at a home in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: newPatioCedarGrove,
    title: "Paver Patio Installation",
    location: "Cedar Grove, Essex County, NJ",
    alt: "New paver patio with dark border and masonry steps installed at a home in Cedar Grove, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8571,
    lng: -74.2290,
  },
  {
    image: paverPatioWayne2,
    title: "Paver Patio Installation",
    location: "Wayne, Passaic County, NJ",
    alt: "Backyard paver patio installation with herringbone pattern at a home in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: outdoorKitchenFairLawn,
    title: "Outdoor Kitchen Installation",
    location: "Fair Lawn, Bergen County, NJ",
    alt: "Custom outdoor kitchen with granite countertop, built-in grill, and refrigerator on a stamped paver patio in Fair Lawn, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9404,
    lng: -74.1318,
  },
  {
    image: retainingWallParamus,
    title: "Retaining Wall Installation",
    location: "Paramus, Bergen County, NJ",
    alt: "Tiered Breezewood retaining wall installation with planting beds beneath a deck in Paramus, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9445,
    lng: -74.0754,
  },
  {
    image: paverPatioBergenfield,
    title: "Paver Patio Installation",
    location: "Bergenfield, Bergen County, NJ",
    alt: "New paver patio walkway installation along the side of a home in Bergenfield, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9276,
    lng: -73.9971,
  },
  {
    image: stonePaverPatioLittleFalls,
    title: "Stone Paver Patio Installation",
    location: "Little Falls, Passaic County, NJ",
    alt: "Large stone paver patio installation in a backyard in Little Falls, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.8826,
    lng: -74.2210,
  },
  {
    image: paverPatioWoodlandPark,
    title: "Paver Patio Installation",
    location: "Woodland Park, Passaic County, NJ",
    alt: "New paver patio with hot tub pad and curved border installed at a blue-sided home in Woodland Park, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.8893,
    lng: -74.1946,
  },
  {
    image: paverPatioWayne3,
    title: "Pool Patio Paver Installation",
    location: "Wayne, Passaic County, NJ",
    alt: "Paver patio surrounding an in-ground pool with dark border and stone fire pit in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9254,
    lng: -74.2765,
  },
  {
    image: patioTotowa2,
    title: "Patio Paver Installation",
    location: "Totowa, Passaic County, NJ",
    alt: "Backyard paver patio installation with stone seat wall and walkway at a home in Totowa, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9054,
    lng: -74.2232,
  },
  {
    image: patioFirePitVerona,
    title: "Patio & Fire Pit Installation",
    location: "Verona, Essex County, NJ",
    alt: "Paver patio with custom stone fire pit and seating wall installed next to a deck in Verona, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8340,
    lng: -74.2432,
  },
  {
    image: firePitEssexFells2,
    title: "Fire Pit Installation",
    location: "Essex Fells, Essex County, NJ",
    alt: "Custom stone fire pit with retaining wall seating area installed on a paver patio in Essex Fells, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8254,
    lng: -74.2835,
  },
  {
    image: paverPatioNutley2,
    title: "Paver Patio & Fire Pit",
    location: "Nutley, Essex County, NJ",
    alt: "Paver patio installation with built-in fire pit and outdoor grill station at a residential home in Nutley, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8223,
    lng: -74.1599,
  },
  {
    image: paverPatioMontclair3,
    title: "Paver Patio & Fire Pit",
    location: "Montclair, Essex County, NJ",
    alt: "Modern gray paver patio with fire pit and outdoor sectional seating area installed in Montclair, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8259,
    lng: -74.2090,
  },
  {
    image: paverPatioFairLawn,
    title: "Paver Patio & Fire Pit",
    location: "Fair Lawn, Bergen County, NJ",
    alt: "Paver patio with stone fire pit and landscape lighting installed at a backyard in Fair Lawn, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.9404,
    lng: -74.1318,
  },
  {
    image: retainingWallUpperMontclair,
    title: "Retaining Wall Installation",
    location: "Upper Montclair, Essex County, NJ",
    alt: "Block retaining wall with dark cap stones and landscaping installed along a driveway in Upper Montclair, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8451,
    lng: -74.2010,
  },
  {
    image: paverPatioMontclair4,
    title: "Paver Patio & Pool Deck",
    location: "Montclair, Essex County, NJ",
    alt: "Paver patio and pool deck installation with gray interlocking pavers surrounding an inground pool in Montclair, Essex County, NJ, by Masonry Pro Construction.",
    lat: 40.8259,
    lng: -74.2090,
  },
  {
    image: paverWalkwayRutherford,
    title: "Paver Walkway & Steps",
    location: "Rutherford, Bergen County, NJ",
    alt: "Curved paver walkway and stone veneer steps leading to the front entrance of a home in Rutherford, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8265,
    lng: -74.1068,
  },
  {
    image: paverPatioLittleFerry,
    title: "Paver Patio & Pool Deck",
    location: "Little Ferry, Bergen County, NJ",
    alt: "Paver patio and pool deck installation alongside an inground pool in Little Ferry, Bergen County, NJ, by Masonry Pro Construction.",
    lat: 40.8504,
    lng: -74.0421,
  },
  {
    image: masonryStairsCedarGrove,
    title: "Masonry Stairs Installation",
    location: "Cedar Grove, Essex County, NJ",
    alt: "New masonry stairs install by a masonry contractor on a home in Cedar Grove, Essex County, NJ by Masonry Pro Construction",
    lat: 40.8595,
    lng: -74.2073,
  },
  {
    image: stoopsStepsTotowa,
    title: "Stoops & Steps Installation",
    location: "Totowa, Passaic County, NJ",
    alt: "New brick stoops and steps installation with concrete treads at a residential home in Totowa, Passaic County, NJ, by Masonry Pro Construction.",
    lat: 40.9048,
    lng: -74.2232,
  },
  {
    image: poolPaverPatioBloomfield,
    title: "Pool Paver Patio Installation",
    location: "Bloomfield, Essex County, NJ",
    alt: "New swimming pool and paver patio installation in a residential backyard in Bloomfield, Essex County, NJ. Masonry Pro",
    lat: 40.83758,
    lng: -74.17200,
  },
  {
    image: paverPatioFirePitClifton,
    title: "Paver Patio with Fire Pit Clifton NJ",
    location: "Clifton, Passaic County, New Jersey, United States",
    alt: "Paver patio with a fire pit and retaining wall, installed by Masonry Pro Construction at Clifton, Passaic County, New Jersey",
    lat: 40.869019,
    lng: -74.187356,
  },
  {
    image: stepsInstallationClifton,
    title: "Stone Steps and Stoop Installation Passaic NJ",
    location: "Passaic, Passaic County, New Jersey, 07055, United States",
    alt: "New stone steps and stoop installation leading to a black door in Passaic, Passaic County, NJ. Masonry Pro Construction",
    lat: 40.861740,
    lng: -74.131117,
  },
  {
    image: concreteDrivewayClifton,
    title: "Concrete Driveway Installation Clifton NJ",
    location: "Clifton, Passaic County, New Jersey, United States",
    alt: "New concrete driveway leading to a two-car garage at a residential property in Clifton, Passaic County, NJ. Masonry Pro Construction",
    lat: 40.875791833847599,
    lng: -74.142253469876862,
  },
  {
    image: stepsPassaic2,
    title: "Stone Steps and Stoop Installation Passaic NJ",
    location: "Passaic, Passaic County, New Jersey, 07055, United States",
    alt: "New stone steps and stoop installation leading to a black door in Passaic, Passaic County, NJ. Masonry Pro Construction",
    lat: 40.861739,
    lng: -74.131117,
  },
  {
    image: patioWalkwayPassaic,
    title: "Patio Walkway Paving Passaic NJ",
    location: "Passaic, Passaic County, New Jersey, 07055, United States",
    alt: "Newly paved patio and walkway between two brick buildings in Passaic, Passaic County, NJ. Masonry Pro Construction",
    lat: 40.858474,
    lng: -74.127074,
  },
  {
    image: illuminatedStepsVerona,
    title: "Illuminated Paver Steps Installation",
    location: "Verona, Essex County, New Jersey, 07044, United States",
    alt: "Illuminated paver steps provide a safe walkway at night in Verona, Essex County, NJ. Masonry Pro Construction",
    lat: 40.82873611,
    lng: -74.25203611,
  },
  {
    image: stepsPavedWalkwayVerona,
    title: "Steps & Paved Walkway Installation",
    location: "Verona, Essex County, New Jersey, 07044, United States",
    alt: "Newly installed paver steps and walkway leading up to a home in Verona, Essex County, NJ. Masonry Pro Construction",
    lat: 40.82873611,
    lng: -74.25203611,
  },
  {
    image: paverPatioInstPequannock2,
    title: "Paver Patio Installation",
    location: "Pequannock Township, Morris County, New Jersey, United States",
    alt: "New paver patio installation with a gazebo and outdoor furniture in Pequannock Township, Morris County, NJ.",
    lat: 40.96471666666667,
    lng: -74.30185,
  },
];
